// Ana sayfa "Normal Görev Durum Dağılımı" pasta grafiği rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'dashboard.normalTaskStatus';

export const normalTaskStatusGuide = (t: TFunction): GuideContent => ({
  layout: 'chart',
  title: t(`${G}.title`, 'Normal Görev Durum Dağılımı nasıl okunur?'),
  intro: t(`${G}.intro`, 'Bu pasta grafik, tek seferlik (normal) görevlerin durumlarına göre dağılımını gösterir. Tekrarlayan görevler dahil değildir. Her durumun yanında o durumdaki görevlerin yüzdesi yazar; dilimin üzerine gelince görev sayısını ve oranını görürsünüz.'),
  chart: {
    kind: 'pie',
    legend: [
      { color: '#FFA000', label: t(`${G}.l1.label`, 'Beklemede'), text: t(`${G}.l1.text`, 'Henüz personele atanmamış veya personel tarafından görülmemiş görevler.') },
      { color: '#1976D2', label: t(`${G}.l2.label`, 'Kabul Edildi'), text: t(`${G}.l2.text`, 'Personel tarafından kabul edilmiş ancak henüz başlanmamış görevler.') },
      { color: '#43A047', label: t(`${G}.l3.label`, 'Başlandı'), text: t(`${G}.l3.text`, 'Personelin üzerinde çalışmaya başladığı görevler.') },
      { color: '#6A1B9A', label: t(`${G}.l4.label`, 'Tamamlandı'), text: t(`${G}.l4.text`, 'Personel tarafından başarıyla tamamlanmış görevler.') },
    ],
    note: t(`${G}.note`, 'Hiç görevi olmayan durumlar grafikte gösterilmez. Şube yöneticisi olarak girdiyseniz veya şube filtresi seçiliyse yalnız o şubenin görevleri sayılır.'),
  },
});
